import { Brain, Flame, Medal, Plane } from "lucide-react";

export const BADGES = {
  traveler: { label: "Traveler", icon: Plane, color: "#b18cff" },
  first_win: { label: "First Brain", icon: Brain, color: "#f5b335" },
  veteran: { label: "Veteran", icon: Medal, color: "#34d8a8" },
  streak_master: { label: "Streak Master", icon: Flame, color: "#ff5a82" },
};

export function BadgeRow({ badges }) {
  const list = (badges || []).filter((b) => BADGES[b]);
  if (!list.length) return null;
  return (
    <div className="flex flex-wrap justify-center gap-2">
      {list.map((b) => {
        const B = BADGES[b];
        return (
          <span
            key={b}
            data-testid={`badge-${b}`}
            className="inline-flex items-center gap-1.5 rounded-full border px-3 py-1 font-mono text-[10px] font-bold uppercase tracking-[0.15em]"
            style={{ borderColor: `${B.color}66`, background: `${B.color}1a`, color: B.color }}
          >
            <B.icon size={12} />
            {B.label}
          </span>
        );
      })}
    </div>
  );
}
